import React from 'react'
import { useForgotForm } from './useForgotForm'
import { ForgotFormView } from './ForgotFormView'

export const ForgotForm: React.FC = () => {
  const props = useForgotForm()
  return <ForgotFormView {...props} />
}
ForgotForm.displayName = 'ForgotForm'

export default ForgotForm
